"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.yesNo = exports.paymentPeriods = exports.opportunityTypeOptions = exports.opportunityFor = exports.locationTypes = exports.gpa = exports.expectedDatesOfHire = exports.durationOptions = exports.compensationTypes = exports.compensationPeriod = exports.applicationPoints = exports.applicantPreferencesOptions = exports.applicantExtraOptions = exports.amAndPm = void 0;
var applicantPreferencesOptions = ['Individually Immediately', 'Daily', 'Weekly', 'Monthly', 'At the close of the Application Window'];
exports.applicantPreferencesOptions = applicantPreferencesOptions;
var applicantExtraOptions = ['HIVE Buzzwords (NEEDS DESCRIPTION)', 'Profile Picture', 'Diversities', 'Wry Our Company', 'Additional Documents (transcript, portfolio, additional questions, traditional cover letter, other writing'];
exports.applicantExtraOptions = applicantExtraOptions;
var opportunityTypeOptions = [{
  id: 'job',
  name: 'Job'
}, {
  id: 'internships',
  name: 'Internship'
}, {
  id: 'event',
  name: 'Event'
}];
exports.opportunityTypeOptions = opportunityTypeOptions;
var durationOptions = [{
  id: 1,
  name: 'Full-time'
}, {
  id: 2,
  name: 'Part-time'
}];
exports.durationOptions = durationOptions;
var paymentPeriods = [{
  id: 1,
  name: 'Hourly',
  preview: '/hour'
}, {
  id: 2,
  name: 'Weekly',
  preview: '/week'
}, {
  id: 3,
  name: 'Monthly',
  preview: '/month'
}, {
  id: 4,
  name: 'Annual Salary',
  preview: '/year'
}];
exports.paymentPeriods = paymentPeriods;
var locationTypes = [{
  id: 1,
  name: 'In-Person'
}, {
  id: 2,
  name: 'Remote'
}, {
  id: 3,
  name: 'Remote or In Person'
}];
exports.locationTypes = locationTypes;
var compensationTypes = [{
  id: 1,
  name: 'Paid'
}, {
  id: 2,
  name: 'Unpaid'
}];
exports.compensationTypes = compensationTypes;
var expectedDatesOfHire = [{
  id: 1,
  name: 'Immediately'
}, {
  id: 2,
  name: 'Date'
}];
exports.expectedDatesOfHire = expectedDatesOfHire;
var gpa = [{
  id: 4,
  name: 'N/A'
}, {
  id: 1,
  name: '3.0'
}, {
  id: 2,
  name: '3.3'
}, {
  id: 3,
  name: '3.7'
}];
exports.gpa = gpa;
var yesNo = [{
  id: true,
  name: 'Yes'
}, {
  id: false,
  name: 'No'
}];
exports.yesNo = yesNo;
var applicationPoints = [{
  id: 1,
  name: 'US'
}, {
  id: 2,
  name: 'International'
}];
exports.applicationPoints = applicationPoints;
var compensationPeriod = [{
  id: 1,
  name: 'Hourly',
  preview: '/hour'
}, {
  id: 2,
  name: 'Weekly',
  preview: '/week'
}, {
  id: 3,
  name: 'Monthly',
  preview: '/month'
}];
exports.compensationPeriod = compensationPeriod;
var opportunityFor = [{
  id: 1,
  name: 'Parent Company'
}, {
  id: 2,
  name: 'Internal/Regional division'
}, {
  id: 3,
  name: 'Subsidiary'
}];
exports.opportunityFor = opportunityFor;
var amAndPm = [{
  id: true,
  name: 'AM'
}, {
  id: false,
  name: 'PM'
}];
exports.amAndPm = amAndPm;